{
	"v": "5.9.0",
	"fr": 29.9700012207031,
	"ip": 0,
	"op": 95.0000038694293,
	"w": 1920,
	"h": 1080,
	"nm": "Comp 1",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Shape Layer 3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						502.345,
						0,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"ef": [
				{
					"ty": 29,
					"nm": "Gaussian Blur",
					"np": 5,
					"mn": "ADBE Gaussian Blur 2",
					"ix": 1,
					"en": 1,
					"ef": [
						{
							"ty": 0,
							"nm": "Blurriness",
							"mn": "ADBE Gaussian Blur 2-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 50.4,
								"ix": 1
							}
						},
						{
							"ty": 7,
							"nm": "Blur Dimensions",
							"mn": "ADBE Gaussian Blur 2-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 2
							}
						},
						{
							"ty": 7,
							"nm": "Repeat Edge Pixels",
							"mn": "ADBE Gaussian Blur 2-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 3
							}
						}
					]
				},
				{
					"ty": 5,
					"nm": "Levels",
					"np": 11,
					"mn": "ADBE Easy Levels2",
					"ix": 2,
					"en": 1,
					"ef": [
						{
							"ty": 7,
							"nm": "Channel:",
							"mn": "ADBE Easy Levels2-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 1
							}
						},
						{},
						{
							"ty": 0,
							"nm": "Input Black",
							"mn": "ADBE Easy Levels2-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 3
							}
						},
						{
							"ty": 0,
							"nm": "Input White",
							"mn": "ADBE Easy Levels2-0004",
							"ix": 4,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 4
							}
						},
						{
							"ty": 0,
							"nm": "Gamma",
							"mn": "ADBE Easy Levels2-0005",
							"ix": 5,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 5
							}
						},
						{
							"ty": 0,
							"nm": "Output Black",
							"mn": "ADBE Easy Levels2-0006",
							"ix": 6,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 6
							}
						},
						{
							"ty": 0,
							"nm": "Output White",
							"mn": "ADBE Easy Levels2-0007",
							"ix": 7,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 7
							}
						},
						{
							"ty": 7,
							"nm": "Clip To Output Black",
							"mn": "ADBE Easy Levels2-0008",
							"ix": 8,
							"v": {
								"a": 0,
								"k": 3,
								"ix": 8
							}
						},
						{
							"ty": 7,
							"nm": "Clip To Output White",
							"mn": "ADBE Easy Levels2-0009",
							"ix": 9,
							"v": {
								"a": 0,
								"k": 3,
								"ix": 9
							}
						}
					]
				},
				{
					"ty": 5,
					"nm": "CC Radial Fast Blur",
					"np": 5,
					"mn": "CC Radial Fast Blur",
					"ix": 3,
					"en": 1,
					"ef": [
						{
							"ty": 3,
							"nm": "Center",
							"mn": "CC Radial Fast Blur-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": [
									960,
									540
								],
								"ix": 1
							}
						},
						{
							"ty": 0,
							"nm": "Amount",
							"mn": "CC Radial Fast Blur-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 51,
								"ix": 2
							}
						},
						{
							"ty": 7,
							"nm": "Zoom",
							"mn": "CC Radial Fast Blur-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 3
							}
						}
					]
				}
			],
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 2,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									317.555,
									317.555
								],
								"ix": 2
							},
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.667,
											"y": 1
										},
										"o": {
											"x": 0.333,
											"y": 0
										},
										"t": 50.479,
										"s": [
											1486.1,
											615.223
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.667,
											"y": 1
										},
										"o": {
											"x": 0.333,
											"y": 0
										},
										"t": 63,
										"s": [
											1486.1,
											400
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.667,
											"y": 1
										},
										"o": {
											"x": 0.333,
											"y": 0
										},
										"t": 72.74,
										"s": [
											1486.1,
											575.917
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.667,
											"y": 1
										},
										"o": {
											"x": 0.333,
											"y": 0
										},
										"t": 79,
										"s": [
											1486.1,
											528.917
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 82.0000033399285,
										"s": [
											1486.1,
											615.223
										]
									}
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "gf",
							"o": {
								"a": 0,
								"k": 100,
								"ix": 10
							},
							"r": 1,
							"bm": 0,
							"g": {
								"p": 3,
								"k": {
									"a": 0,
									"k": [
										0,
										0.594,
										0.384,
										0.713,
										0.461,
										0.777,
										0.645,
										0.66,
										1,
										0.961,
										0.906,
										0.607
									],
									"ix": 9
								}
							},
							"s": {
								"a": 0,
								"k": [
									1244.484,
									582.344
								],
								"ix": 5
							},
							"e": {
								"a": 0,
								"k": [
									1727.031,
									624.016
								],
								"ix": 6
							},
							"t": 1,
							"nm": "Gradient Fill 1",
							"mn": "ADBE Vector Graphic - G-Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-497.223,
									10
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 900.000036657751,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Shape Layer 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 0.667
							},
							"o": {
								"x": 0.333,
								"y": 0.333
							},
							"t": 20.479,
							"s": [
								1486.1,
								615.223,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0.076
							},
							"t": 21,
							"s": [
								1486.1,
								615.223,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 33,
							"s": [
								1486.1,
								400,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 42.74,
							"s": [
								1486.1,
								575.917,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 49,
							"s": [
								1486.1,
								528.917,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 52.0000021180034,
							"s": [
								1486.1,
								615.223,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"ef": [
				{
					"ty": 29,
					"nm": "Gaussian Blur",
					"np": 5,
					"mn": "ADBE Gaussian Blur 2",
					"ix": 1,
					"en": 1,
					"ef": [
						{
							"ty": 0,
							"nm": "Blurriness",
							"mn": "ADBE Gaussian Blur 2-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 50.7,
								"ix": 1
							}
						},
						{
							"ty": 7,
							"nm": "Blur Dimensions",
							"mn": "ADBE Gaussian Blur 2-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 2
							}
						},
						{
							"ty": 7,
							"nm": "Repeat Edge Pixels",
							"mn": "ADBE Gaussian Blur 2-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 3
							}
						}
					]
				},
				{
					"ty": 5,
					"nm": "Levels",
					"np": 11,
					"mn": "ADBE Easy Levels2",
					"ix": 2,
					"en": 1,
					"ef": [
						{
							"ty": 7,
							"nm": "Channel:",
							"mn": "ADBE Easy Levels2-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 1
							}
						},
						{},
						{
							"ty": 0,
							"nm": "Alpha Input Black",
							"mn": "ADBE Easy Levels2-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 3
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Input White",
							"mn": "ADBE Easy Levels2-0004",
							"ix": 4,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 4
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Gamma",
							"mn": "ADBE Easy Levels2-0005",
							"ix": 5,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 5
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Output Black",
							"mn": "ADBE Easy Levels2-0006",
							"ix": 6,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 6
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Output White",
							"mn": "ADBE Easy Levels2-0007",
							"ix": 7,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 7
							}
						},
						{
							"ty": 7,
							"nm": "Clip To Output Black",
							"mn": "ADBE Easy Levels2-0008",
							"ix": 8,
							"v": {
								"a": 0,
								"k": 3,
								"ix": 8
							}
						},
						{
							"ty": 7,
							"nm": "Clip To Output White",
							"mn": "ADBE Easy Levels2-0009",
							"ix": 9,
							"v": {
								"a": 0,
								"k": 3,
								"ix": 9
							}
						}
					]
				},
				{
					"ty": 5,
					"nm": "CC Radial Fast Blur",
					"np": 5,
					"mn": "CC Radial Fast Blur",
					"ix": 3,
					"en": 1,
					"ef": [
						{
							"ty": 3,
							"nm": "Center",
							"mn": "CC Radial Fast Blur-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": [
									960,
									540
								],
								"ix": 1
							}
						},
						{
							"ty": 0,
							"nm": "Amount",
							"mn": "CC Radial Fast Blur-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 51,
								"ix": 2
							}
						},
						{
							"ty": 7,
							"nm": "Zoom",
							"mn": "CC Radial Fast Blur-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 3
							}
						}
					]
				}
			],
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									317.555,
									317.555
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.749019607843,
									0.388235294118,
									0.952941176471,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-497.223,
									10
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 900.000036657751,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						2454.1,
						1191.14,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 1,
							"s": [
								1486.1,
								615.223,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 8,
							"s": [
								1486.1,
								784.917,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 15,
							"s": [
								1486.1,
								575.917,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 21.441,
							"s": [
								1486.1,
								615.223,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 24.00000097754,
							"s": [
								1486.1,
								575.917,
								0
							]
						}
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"ef": [
				{
					"ty": 29,
					"nm": "Gaussian Blur",
					"np": 5,
					"mn": "ADBE Gaussian Blur 2",
					"ix": 1,
					"en": 1,
					"ef": [
						{
							"ty": 0,
							"nm": "Blurriness",
							"mn": "ADBE Gaussian Blur 2-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 46.3,
								"ix": 1
							}
						},
						{
							"ty": 7,
							"nm": "Blur Dimensions",
							"mn": "ADBE Gaussian Blur 2-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 2
							}
						},
						{
							"ty": 7,
							"nm": "Repeat Edge Pixels",
							"mn": "ADBE Gaussian Blur 2-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 3
							}
						}
					]
				},
				{
					"ty": 5,
					"nm": "Levels",
					"np": 11,
					"mn": "ADBE Easy Levels2",
					"ix": 2,
					"en": 1,
					"ef": [
						{
							"ty": 7,
							"nm": "Channel:",
							"mn": "ADBE Easy Levels2-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 1
							}
						},
						{},
						{
							"ty": 0,
							"nm": "Alpha Input Black",
							"mn": "ADBE Easy Levels2-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 3
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Input White",
							"mn": "ADBE Easy Levels2-0004",
							"ix": 4,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 4
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Gamma",
							"mn": "ADBE Easy Levels2-0005",
							"ix": 5,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 5
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Output Black",
							"mn": "ADBE Easy Levels2-0006",
							"ix": 6,
							"v": {
								"a": 0,
								"k": 0,
								"ix": 6
							}
						},
						{
							"ty": 0,
							"nm": "Alpha Output White",
							"mn": "ADBE Easy Levels2-0007",
							"ix": 7,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 7
							}
						},
						{
							"ty": 7,
							"nm": "Clip To Output Black",
							"mn": "ADBE Easy Levels2-0008",
							"ix": 8,
							"v": {
								"a": 0,
								"k": 3,
								"ix": 8
							}
						},
						{
							"ty": 7,
							"nm": "Clip To Output White",
							"mn": "ADBE Easy Levels2-0009",
							"ix": 9,
							"v": {
								"a": 0,
								"k": 3,
								"ix": 9
							}
						}
					]
				},
				{
					"ty": 5,
					"nm": "CC Radial Fast Blur",
					"np": 5,
					"mn": "CC Radial Fast Blur",
					"ix": 3,
					"en": 1,
					"ef": [
						{
							"ty": 3,
							"nm": "Center",
							"mn": "CC Radial Fast Blur-0001",
							"ix": 1,
							"v": {
								"a": 0,
								"k": [
									960,
									540
								],
								"ix": 1
							}
						},
						{
							"ty": 0,
							"nm": "Amount",
							"mn": "CC Radial Fast Blur-0002",
							"ix": 2,
							"v": {
								"a": 0,
								"k": 50,
								"ix": 2
							}
						},
						{
							"ty": 7,
							"nm": "Zoom",
							"mn": "CC Radial Fast Blur-0003",
							"ix": 3,
							"v": {
								"a": 0,
								"k": 1,
								"ix": 3
							}
						}
					]
				}
			],
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									317.555,
									317.555
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "gf",
							"o": {
								"a": 0,
								"k": 100,
								"ix": 10
							},
							"r": 1,
							"bm": 0,
							"g": {
								"p": 3,
								"k": {
									"a": 0,
									"k": [
										0,
										0,
										0.396,
										1,
										0.724,
										0.182,
										0.396,
										1,
										1,
										0.364,
										0.396,
										1
									],
									"ix": 9
								}
							},
							"s": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 5
							},
							"e": {
								"a": 0,
								"k": [
									100,
									0
								],
								"ix": 6
							},
							"t": 1,
							"nm": "Gradient Fill 1",
							"mn": "ADBE Vector Graphic - G-Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									-497.223,
									10
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 900.000036657751,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
}
